import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import * as PaymentRemindersService from '../../../services/api/payment_reminders';
import { useSelector } from 'react-redux';
import { IState } from './reducer';

interface PaymentRemindersListOutput {
  status: StateStatus;
  data: PaymentRemindersService.IPaymentRemindersListOutput | null;
}

export const useGetPaymentRemindersList = (): PaymentRemindersListOutput => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.PAYMENT_REMINDER_REDUCER].paymentRemindersList
  );
  return data;
};

export const useGetPaymentRemindersGenerateStatus = ():
  | StateStatus
  | undefined => {
  const data = useSelector(
    (state: any) =>
      (state[ReducerKeys.PAYMENT_REMINDER_REDUCER] as IState)
        .paymentRemindersGenerateStatus
  );
  return data;
};
